<template>
  <div class="star-particles fixed inset-0 pointer-events-none z-0 overflow-hidden">
    <div
      v-for="star in stars"
      :key="star.id"
      class="star"
      :style="{
        left: star.x + '%',
        top: star.y + '%',
        width: star.size + 'px',
        height: star.size + 'px',
        animationDelay: star.delay + 's',
        animationDuration: star.duration + 's',
        opacity: star.opacity
      }"
    ></div>
    <div
      v-for="(shooting, i) in shootingStars"
      :key="'shooting-' + i"
      class="shooting-star-custom"
      :style="{
        left: shooting.x + '%',
        top: shooting.y + '%',
        animationDelay: shooting.delay + 's',
        animationDuration: shooting.duration + 's'
      }"
    ></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const stars = ref([])
const shootingStars = ref([])

onMounted(() => {
  // 生成 200 颗静态星星
  const starArray = []
  for (let i = 0; i < 200; i++) {
    starArray.push({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2.5 + 0.5,
      delay: Math.random() * 5,
      duration: Math.random() * 3 + 2,
      opacity: Math.random() * 0.7 + 0.3
    })
  }
  stars.value = starArray

  // 生成 3 颗流星
  const shootingArray = []
  for (let i = 0; i < 3; i++) {
    shootingArray.push({
      x: Math.random() * 100,
      y: Math.random() * 30,
      delay: Math.random() * 15 + 5,
      duration: Math.random() * 2 + 1.5
    })
  }
  shootingStars.value = shootingArray
})
</script>

<style scoped>
.star-particles {
  background: transparent;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  animation: twinkle ease-in-out infinite alternate;
}

@keyframes twinkle {
  0% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.shooting-star-custom {
  position: absolute;
  width: 2px;
  height: 2px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.3);
  animation: shoot linear infinite;
}

.shooting-star-custom::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 100%;
  width: 80px;
  height: 1px;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.6), transparent);
}

@keyframes shoot {
  0% {
    opacity: 1;
    transform: translate(0, 0) rotate(-35deg);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(-300px, 200px) rotate(-35deg);
  }
}
</style>